var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M14.74 1.2L9.42 6.63v7.63a.7.7 0 01-.68.72.72.72 0 01-.42-.13l-2.33-1.6a.72.72 0 01-.32-.57v-6L.18 1.34a.69.69 0 010-1A.73.73 0 01.7.12l13.5-.14a.7.7 0 01.75.64.74.74 0 01-.21.58z","fill":"currentColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }